import React, { Component } from 'react';
import TestShare from './share';
import axios from 'axios'
// import { withCookies, Cookies } from 'react-cookie';
import {sendEvent} from "../../helpers/analytics";
import {BASE_URL} from "../../config";

class Finish extends Component {

  componentDidMount () {
    sendEvent('game', 'load', 'result')
  }

  componentWillMount () {
    const {time, score, token } = this.props
    let formData = new FormData();
    formData.append('time', time);
    formData.append('score', score);

    localStorage.setItem('agree', 'false')

    let authToken = {'Authorization': 'Bearer ' + token}

    axios({
      url: BASE_URL +'/new/3/',
      method: 'post',
      headers: authToken,
      data: formData
    }).then((res) => {
      console.log(res)
    })
  }

  nextScreen = () => {
    this.props.next(3)
  }

  formatTime (seconds) {
    let minutes = Math.floor(seconds / 60);
    let sec = seconds - minutes * 60;
    let minString = minutes.toString()
    let secString = sec.toString()
    if (minString.length < 2) minString = '0' + minString
    if (secString.length < 2) secString = '0' + secString
    return minString + ':' + secString
  }

  render () {
    let time = this.formatTime(this.props.time)

    return (
      <div className="test__finish">
        <h1 className="h1 h1--finish">финиш!</h1>

        <div className="finish__text">
          <p>
            Вы ответили правильно на {this.props.score} вопросов. Время круга&nbsp;— {time}.  Сразу видно, что вместо сердца у вас пламенный мотор, а ваши мысли устремлены навстречу клетчатому флагу. Так держать!
          </p>
        </div>

        <div className="finish__button">
          <button className="button button--secondary" onClick={() => { this.nextScreen(); sendEvent('game', 'click', 'rating-result') }}>Ваш рейтинг</button>
        </div>

        <TestShare />

      </div>
    )
  }
}

export default Finish


// WEBPACK FOOTER //
// ./src/pages/test/finish.js